import {customSpringAxios} from "../backendAPIs";

export async function getAllDiscountsApi() {
    return customSpringAxios.get(`/api/ticketType?page=0&size=2000`)
}
